import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import Records from '../../components/forms/records';
import ReportFilter from '../../components/forms/records/filters';
import { RECORDS_FILTERS } from '../../redux/types';


const RecordsPage = (props) => {
    // const [defaultFilter, setDefaultFilter] = useState
    // const [filters, setFilters] = useState(props.filters_applied);
    const { formId } = useParams();
    const [allDone, setAllDone] = useState(false);
    let { record_filters } = props;

    const handleOnFilterChange = (_filters) => {
        // setFilters(_filters);
        props.dispatch({
            type: RECORDS_FILTERS,
            payload: _filters
        });
    }

    useEffect(() => {
        if (record_filters?.selectedFormId != formId) {
            record_filters = null;
        }
        setAllDone(true);
    }, []);

    return (
        <div>
            {allDone ? (
                <>
                    <div className="filter-container">
                        <ReportFilter onFilterChange={handleOnFilterChange} default_filter={record_filters} />
                    </div>
                    <Records filters={record_filters} basicRecordInfo={true} />``
                </>
            ) : null}

        </div>
    );
}


// export default RecordsPage;

function mapStateToProps(state) {
    const { record_filters } = state.forms;
    return {
        record_filters
    }
}

export default connect(mapStateToProps)(RecordsPage);